module.exports = __webpack_public_path__ + "img/16d001-04.e6f46451.png";